import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { getCurrentTenant } from '@/modules/tenant/data/tenants';
import { AuthProvider } from '@/modules/auth/presentation/context/AuthProvider';
import { TenantContext } from '@/modules/tenant/presentation/context/tenant-context';
import { configureAnalytics } from './lib/analytics';
import { AppRoutes } from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/** A prova é fixa por build (`VITE_TENANT`), então é resolvida uma vez só. */
const tenant = getCurrentTenant();

// Todo evento do GTM leva a prova e a edição: o relatório separa as provas.
configureAnalytics({ prova: tenant.id, edicao: tenant.edition.year });

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TenantContext.Provider value={tenant}>
        {/* Dentro do QueryClient: sair limpa o cache de quem saiu. */}
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </TenantContext.Provider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
